import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { GeneralService } from '../../_provider/general.service';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { TicketBase } from '../../_interfaces/ticket';

import { ResizeManagerService } from '../../_provider/resize-manager.service';
import { TransferService } from '../../_provider/transfer.service';
import { ModalController, NavController, Platform, PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Address, AddressBase } from '../../_interfaces/address';
import { HttpFunctionResult } from '../../_interfaces/HttpFunctionResult';
import { CrmService } from '../../_provider/crm.service';
import { AddContactPersonPage } from './add-contact-person/add-contact-person.page';
import { ContactPerson } from '../../_interfaces/ContactPerson';
import { TicketDetailPagePage } from '../../_pages/ticket-detail-page/ticket-detail-page.page';
import { PopoverPage } from '../popover/popover.page';
import { EditArt } from '../../_interfaces/EditArt';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { AddTicketPage } from '../popup-content/add-ticket/add-ticket.page';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';
import { ContactPersonDetailPage } from './contact-person-detail/contact-person-detail.page';
import { CrmEditPage } from 'src/app/_pages/crm/crm-edit/crm-edit.page';
import { SaveService } from 'src/app/_provider/save.service';

@Component({
    selector: 'app-crm-detail',
    templateUrl: './crm-detail.component.html',
    styleUrls: ['./crm-detail.component.scss'],
    standalone: false
})

export class CrmDetailComponent {

  @ViewChild('crmDetail', {static: false}) crmDetail: ElementRef; 
  @Output() updateCrm: EventEmitter<Address> = new EventEmitter<Address>(null)
  @Output() deleteCrm: EventEmitter<number> = new EventEmitter<number>(null)

  public crm: Address
  public isDarkmode: boolean
  public tickets: TicketBase[] = []
  public contactPerson: ContactPerson[] = []
  public searchText: string = ""
  public searchTextContactPerson: string = ""
  private managerId: number

  public isLoading: boolean = true

  public desktopSegment: string = "contactPerson"
  public mobileSegment: string = "details"

  private resizeSub: Subscription
  private activeCRMSub: Subscription

  constructor(
    public general: GeneralService, 
    private darkmode: DarkmodeService, 
    public resizeManager: ResizeManagerService,
    public crmSrv: CrmService,
    private platform: Platform,
    private saveSrv: SaveService.CRM,
    private feedback: FeedbackService,
    private breadcrmbSrv: BreadcumbService,
    private changeDetector:ChangeDetectorRef) {
    this.activeCRMSub = this.general.activeCrm.subscribe(async (result: AddressBase)=>{
      this.breadcrmbSrv.breadcrumbs.splice(1)
      if(!result) return
      this.isLoading = true
      
      //Daten der Adressse holen
      this.crmSrv.getSingleAddress(result.managerId).then(async (result: HttpFunctionResult<Address>)=>{

        //Breadcrumbsachen machen
        this.breadcrmbSrv.breadcrumbs.push({
          name: result.data.description, 
          action: ()=> {}
        })

        if(!this.general.webConfig.hasManagerConnection) this.breadcrmbSrv.buttons = [
          {
            ionIcon: "fa-pen",
            title: "Bearbeiten",
            action: async (event: any) => await this.editAddress()
          },
          {
            ionIcon: "fa-trash",
            title: "Löschen",
            action: async (event: any) => await this.deleteAddress()
          }
        ]

        this.isLoading = false

        if(!result.success) return
        this.crm = result.data

        //Daten für Kontaktpersonen holen
        await this.loadContactPersons(result.data.managerId)
        setTimeout(() => {
          
        }, 0);
      })

      //Tickets der Adresse holen
      await this.loadTickets(result.managerId)


    })
    this.darkmode.isDarkMode.subscribe((result: boolean)=>{
      this.isDarkmode = result
    })
  }
  
  ngOnDestroy(){
    if(this.resizeSub) this.resizeSub.unsubscribe()
    this.activeCRMSub.unsubscribe()

  }
  private async loadTickets(id: number){
    this.crmSrv.getTicketsByAddressId(id, this.searchText).then((result: HttpFunctionResult<TicketBase[]>)=>{
      if(result.success) this.tickets = result.data
    })
  }

  private async loadContactPersons(id: number){
    const contactPersonResult: HttpFunctionResult<ContactPerson[]> = await this.crmSrv.getBasicContactPersonList(id, this.searchTextContactPerson)
    if(contactPersonResult.success) this.contactPerson = contactPersonResult.data
  }

  async openTicket(ticket: TicketBase){
    this.general.setActiveTicket(ticket)
    await this.feedback.openModal(TicketDetailPagePage, {isModal: true})
  }

  // private searchTimeout: any
  // public searchTickets(){
  //   clearTimeout(this.searchTimeout)
  //   this.searchTimeout = setTimeout(() => {
  //     this.loadTickets(this.crm.managerId)
  //   }, 300);
  // }

  // private searchContactPersonTimeout: any
  // public searchContactPersons(){
  //   clearTimeout(this.searchContactPersonTimeout)
  //   this.searchContactPersonTimeout = setTimeout(() => {
  //     this.loadContactPersons(this.crm.managerId)
  //   }, 300);
  // }

  public async openContactPersonPopup(contactPerson: ContactPerson = null, event?: any){
    event?.stopPropagation()
    await this.feedback.openModal<ContactPerson>(
      AddContactPersonPage,
      {addressId: this.crm.managerId, contactPerson: contactPerson ? Object.assign({}, contactPerson) : {}, employeeCanSetOnlinePermission: this.crm.employeeCanSetOnlinePermission},
      (result: HttpFunctionResult<ContactPerson>)=>{
        if(!result.success) return
        if(contactPerson){
          this.contactPerson.splice(this.contactPerson.findIndex(cp => cp.managerId == result.data.managerId), 1, result.data)
        }else{
          this.contactPerson.push(result.data)
        }
      }
    )
  }

  public openMaps(){
    const direction: string = `${encodeURIComponent(this.crm.street) || ""}+${encodeURIComponent(this.crm.plz) || ""}+${encodeURIComponent(this.crm.town) || ""}` 
    if(this.platform.is("ios")){
      window.open(`maps://?q=${direction}`, "_system")
    }else{
      window.open(`https://www.google.com/maps/search/${direction}`, "_system")
    }
  }

  public async addTicket(){
    await this.feedback.openModal<TicketBase>(AddTicketPage, {kunde: this.general.activeCrmValue}, (result: HttpFunctionResult<TicketBase>)=>{
      if(!result.success) return
      this.tickets.push(result.data)
      this.openTicket(result.data)
    })
  }

  public async openLinkType(type: "telefone" | "telefoneTwo" | "mobile" | "email" | "website"){

    const value: string = this.crm[type]

    if(!value){
      await this.feedback.showError("Keine Daten hinterlegt zum Kontaktieren.")
      return
    }

    if(type == "telefone" || type == "telefoneTwo" || type == "mobile")
      window.open(`tel:${value}`, "_system")
    else if(type == "email") 
      window.open(`mailto:${value}`, "_system")
    else if(type == "website"){
      const website: string = value.startsWith("http") ? value : `https://${value}`
      window.open(website, "_system")
    }

  }

  public async openContactPersonDetail(contactPerson: ContactPerson){
    await this.feedback.openModal(ContactPersonDetailPage, {contactPerson: contactPerson}, async (result: {success: boolean, data?: string})=>{
      if(result.success && result?.data == "edit") setTimeout(async () => await this.openContactPersonPopup(contactPerson), 250);
    })
  }

  private async editAddress(){
    await this.feedback.openModal(CrmEditPage, {isNew: false, crm: this.crm}, (result: HttpFunctionResult<Address>)=>{
      if(!result.success) return
      this.updateCrm.emit(result.data)
    })
  }

  private async deleteAddress(){
    if(!(await this.feedback.confirm(`Sind Sie sicher, dass die Adresse "${this.crm.description}" wirklich gelöscht werden soll?`))) return
    await this.feedback.updateLoading("Löschen...")
    const result: HttpFunctionResult<any> = await this.saveSrv.deleteAddress(this.crm.managerId)
    await this.feedback.hideLoading()
    if(!result) return
    this.deleteCrm.emit(this.crm.managerId)
  }

}
